const GROUP_REG = /(?:\{([^}]+)\})?(.+)/;

export default function getFunctionSelectOption(functionName: string): [string, string | undefined] {
    const [, group, name] = functionName.match(GROUP_REG) ?? [];
    const label = (name ?? '').trim();
    if (group) return [label, group.trim()];
    return [label, group];
}
